import React, { useEffect, useState } from "react";
import Edit from "../../Assets/img/Edit.svg";
import { useNavigate } from "react-router-dom";
import View from "../../Assets/img/Eye.svg";
import "../Services/Services.css";
import Search from "../../Assets/img/search.png";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";

const AboutUs = () => {
    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [aboutus, setAboutus] = useState([]);
    const [loading, setLoading] = useState(true);
    const [languageId, setLanguageId] = useState(1);

    // Redirect Map
    const redirectMap = {
        "banner": "aboutbanneredit",
        "bannière": "aboutbanneredit",

        "about us": "aboutusedit",
        "à propos de nous": "aboutusedit",

        "founder profile": "founderedit",
        "profil du fondateur": "founderedit",

        "our story": "ourstoryedit",
        "notre histoire": "ourstoryedit",

        "our mission": "ourmissionedit",
        "notre mission": "ourmissionedit",
    };

    const normalize = (str) =>
        str.replace(/\s+/g, " ").trim().toLowerCase();

    const fetchAboutus = () => {
        setLoading(true);

        let payload = { search, status, language_id: languageId, };

        API.post("about_list/condition", payload)
            .then((response) => {
                const list = response?.data?.data?.data || [];

                const updatedList = list.map((item) => {
                    const key = normalize(item.about_name);
                    return {
                        ...item,
                        redirect: redirectMap[key] || "",
                        ourabout_id: item.ourabout_id
                    };
                });

                setAboutus(updatedList);
            })
            .catch((err) => {
                console.error("Error:", err);
                setAboutus([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchAboutus();
    }, []);

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";

        setLoading(true);

        API.post("about_status/update", {
            about_id: id,
            status: newStatus,
        })
            .then(() => fetchAboutus())
            .catch((err) => console.error("Failed to update status:", err))
            .finally(() => setLoading(false));
    };

    const isBanner = (name) => {
        const n = normalize(name);
        return n === "banner" || n === "bannière";
    };
    const bannerList = aboutus.filter((item) => isBanner(item.about_name));
    const otherList = aboutus.filter((item) => !isBanner(item.about_name));
    return (
        <div className="services-container1">

            {/* HEADER */}
            <div className="services-header1">
                <h2 className="services-title1">About us</h2>
            </div>

            {/* FILTER SECTION */}
            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search By</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search AboutUs..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="category-filter-block1">
                    <label>Status</label>
                    <div className="category-input-container1">
                        <select
                            className="category-input-field1"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                            }}
                            value={languageId}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>

                <div
                    className="filter-btn-wrapper"
                    onClick={() => fetchAboutus()}
                >
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    {/* BANNER CARD */}
                    {bannerList.length > 0 && (
                        <div className="services-grid2">
                            {bannerList.map((item) => (
                                <div className="services-card1" key={item.about_id}>
                                    <p>{item.about_name}</p>

                                    <div className="card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(
                                                            item.about_id,
                                                            item.status
                                                        )
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-btn1"
                                                onClick={() => navigate("/aboutbanneredit")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* OTHER SERVICES */}
                    {otherList.length > 0 && (
                        <div className="services-grid3">
                            {otherList.map((item) => (
                                <div className="services-card1" key={item.about_id}>
                                    <p>{item.about_name}</p>

                                    <div className="card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(
                                                            item.about_id,
                                                            item.status
                                                        )
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-btn1"
                                                onClick={() => {

                                                    // aboutusedit
                                                    if (item.redirect === "aboutusedit") {
                                                        navigate(`/aboutusedit/${item.about_id}?lang=${languageId}`);
                                                        return;
                                                    }

                                                    // founderprofileedit
                                                    if (item.redirect === "founderedit") {
                                                        navigate(`/founderedit/${item.about_id}?lang=${languageId}`);
                                                        return;
                                                    }

                                                    // ourstoryedit
                                                    if (item.redirect === "ourstoryedit") {
                                                        navigate(`/ourstoryedit/${item.about_id}?lang=${languageId}`);
                                                        return;
                                                    }
                                                    //ourmissionedit
                                                    if (item.redirect === "ourmissionedit") {
                                                        navigate(`/ourmissionedit/${item.about_id}?lang=${languageId}`);
                                                        return;
                                                    }

                                                    // DEFAULT
                                                    navigate(`/${item.redirect}`);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* NO DATA MESSAGE */}
                    {bannerList.length === 0 && otherList.length === 0 && (
                        <p className="no-news-text">No AboutUs found.</p>
                    )}
                </>
            )}
        </div>
    );
};

export default AboutUs;
